// Extraído de App.js sem alteração de comportamento.
import { loadLS } from "./storage";

// ── SOUND: bloco concluído ────────────────────────────────────────────────────
// Toca um som curto quando um bloco/revisão termina, se o usuário tiver
// ativado "Sons ao completar bloco" nas configurações do Perfil.
let _blockSoundAudioCtx = null;
export function playBlockCompleteSound() {
  try {
    if (!loadLS("sf_soundsEnabled", true)) return;
    if (!_blockSoundAudioCtx) {
      _blockSoundAudioCtx = new (window.AudioContext || window.webkitAudioContext)();
    }
    const ctx = _blockSoundAudioCtx;
    if (ctx.state === "suspended") ctx.resume();
    const playTone = (freq, startTime, dur = 0.22, vol = 0.35) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = "sine";
      osc.frequency.value = freq;
      gain.gain.setValueAtTime(vol, startTime);
      gain.gain.exponentialRampToValueAtTime(0.001, startTime + dur);
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.start(startTime);
      osc.stop(startTime + dur);
    };
    const now = ctx.currentTime;
    playTone(660, now, 0.16);
    playTone(880, now + 0.16, 0.32);
  } catch {}
}

// Desbloqueia o áudio dentro de um toque (o iPhone só toca som depois de uma interação)
export function primeSound() {
  try {
    if (!_blockSoundAudioCtx) _blockSoundAudioCtx = new (window.AudioContext || window.webkitAudioContext)();
    if (_blockSoundAudioCtx.state === "suspended") _blockSoundAudioCtx.resume();
  } catch {}
}
// Alerta de fim de tempo: alguns apitos seguidos
export function playTimeUpAlert() {
  playBlockCompleteSound();
  setTimeout(playBlockCompleteSound, 700);
  setTimeout(playBlockCompleteSound, 1400);
  try { if (navigator.vibrate) navigator.vibrate([300, 150, 300, 150, 300]); } catch {}
}
